import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import useAuthStore from '@/stores/useAuthStore'
import { IPermissionProps } from '@/types/shared'
import React from 'react'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'
import { getDayOffByID } from '../../services'
import { DayOffCreatePage } from '../Create'

import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const DayOffUpdate: React.FC<IPermissionProps> = () => {
    const { id } = useParams<{ id: string }>()
    const { employee } = useAuthStore()
    const { data, refetch, renderState } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.DAY_OFFS, id],
        queryFn: async () => {
            try {
                const response = await getDayOffByID(Number(id))
                if (employee?.employee_id !== response?.result?.employee_id) {
                    toast.error('You are not allowed to update this day off')
                }
                return response
            } catch {
                // if (error instanceof Error) {
                //     // toast.error(error.message)
                // }
            }
        },
    })
    const stateComponent = renderState()
    if (stateComponent) return stateComponent
    if (employee?.employee_id !== data?.result?.employee_id)
        return <ErrorPage status={500} />
    return (
        <>
            <DayOffCreatePage
                pageType="update"
                dayOff={
                    employee?.employee_id === data?.result?.employee_id
                        ? data?.result
                        : null
                }
                refetchData={refetch}
            />
        </>
    )
}

export default DayOffUpdate
